<div class="w-100 h-100" *ngIf="!showOtp">
    <div class="banner-img">
</div>
    <div class="mt-4 d-flex  align-items-center justify-content-center ">
        <div class="w-75 mb-4">
            <form autocomplete="off" [formGroup]="setPasswordForm">

        <h3 class="mb-3">Set Password</h3>
        <p class="font-weight-500 font-size-3">Your new password</p>
        <mat-form-field class="w-100">
            <mat-label>Enter your new password</mat-label>
            <input matInput formControlName="password" />
            <mat-error id="error_email_required"
            *ngIf="hasError(setPasswordForm,'password','required')">
           Required
        </mat-error>
        <mat-error id="error_email_pattern"
            *ngIf="hasError(setPasswordForm ,'password', 'pattern')">Must be at least 8 characters, have numbers, letters and special chars</mat-error>
        <mat-error id="error_password_min_length"
            *ngIf="hasError(setPasswordForm ,'password', 'minlength')">
            Min. length is 8
        </mat-error>
        <mat-error id="error_password_min_length"
            *ngIf="hasError(setPasswordForm ,'password', 'maxlength')">
            Max. length is 12
        </mat-error>
        </mat-form-field>
        <p class="font-weight-500 font-size-3">Confirm Your new password</p>
        <mat-form-field class="w-100">
            <mat-label>Confirm your new password</mat-label>
            <input matInput formControlName="confirmPassword" />
            <mat-error id="error_userName_required"
                            *ngIf="hasError(setPasswordForm,'confirmPassword','required')">
                           Required </mat-error>
            <mat-error id="error_confirm_password_not_match"
            *ngIf="setPasswordForm.errors?.['passwordNotMatch']==true">
           Passwords not match</mat-error>
        </mat-form-field>
        <button id="login" class="btn primary_large_btn w-100"  [disabled]="!setPasswordForm.valid" (click)="goToOtp()">Set </button>
</form>
    </div>
    </div>
</div>
<app-fund-manager-enter-otp *ngIf="showOtp" [email]="email" [password]="newPassword" [confirmPassword]="confirmPassword"></app-fund-manager-enter-otp>